import React, { useCallback, useContext, useEffect, useState } from "react";
import { getActivityLogData } from "modules/dashboards/actionables/api";
import { Button, Form, Input, message, Modal } from "antd";
import { useMarkShipped, useOrderTracking } from "./store";
import { useToast } from "modules/navbar/top/store/toasterStore";
import { useCustomer } from "modules/dashboards/actionables/store";

function ShipOrders({ isModalVisible, setIsModalVisible, orderId, caseId }) {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [trackingInfo, setTrackingInfo] = useState({
    trackingUrl: "",
    trackingId: "",
  });
  const { markShipped } = useMarkShipped();
  const { setToaster } = useToast();
  const { orderTrackingData, fetchOrderTrackingInfo } = useOrderTracking();
  const { fetchCustomerData } = useCustomer();

  const onModalClose = () => {
    setIsModalVisible(false);
    form.resetFields();
  };

  useEffect(() => {
    form.setFieldsValue(trackingInfo);
  }, [form, trackingInfo]);

  const _getOrderTrackingInfo = useCallback(async () => {
    await fetchOrderTrackingInfo(orderId);
    if (orderTrackingData) setTrackingInfo(orderTrackingData);
  }, [orderId]);

  useEffect(() => {
    if (isModalVisible) _getOrderTrackingInfo(orderId);
  }, [_getOrderTrackingInfo, isModalVisible, orderId]);

  const handleSubmit = async ({ trackingId, trackingUrl }) => {
    let res = {};
    try {
      setLoading(true);
      const data = {
        trackingId: trackingId.trim(),
        trackingUrl: trackingUrl.trim(),
      };
      const rest = await markShipped(data, setToaster);
      await fetchCustomerData(caseId);
      await getActivityLogData(caseId);
      setIsModalVisible(false);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <Modal
        title="Mark Shipped"
        onCancel={onModalClose}
        onOk={onModalClose}
        visible={isModalVisible}
        width={560}
        footer={[
          <Button type="primary" key="back" onClick={onModalClose}>
            Close
          </Button>,
        ]}
      >
        <Form layout="vertical" form={form} onFinish={handleSubmit}>
          <Form.Item
            label="Tracking URL"
            name="trackingUrl"
            rules={[
              {
                required: true,
                message: "Please fill this",
              },
            ]}
          >
            <Input placeholder="Enter URL" />
          </Form.Item>
          <Form.Item
            label="Traking ID"
            name="trackingId"
            rules={[
              {
                required: true,
                message: "Please fill this",
              },
            ]}
          >
            <Input placeholder="Enter Order Id" />
          </Form.Item>
          <Form.Item wrapperCol={{ offset: 10, span: 16 }}>
            <Button type="primary" htmlType="submit" loading={loading}>
              Submit
            </Button>
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
}

export default ShipOrders;
